import { ITextSearchBehavior } from "./ITextSearchBehavior";

export interface ITextSearchBehaviorSpecifiable {
  textSearchBehavior: ITextSearchBehavior;
}

export function instanceOfITextSearchBehaviorSpecifiable(instance: any): instance is ITextSearchBehaviorSpecifiable {
  return instance
    && (instance.textSearchBehavior !== undefined);
}
